<template>
  <div class="versicherungsumfang">
    <template v-for="category in categoriesInfo">

      <v-tooltip v-if="category.long"
                 :key="category.short"
                 nudge-bottom="8"
                 top
                 class="single-versicherungsumfang">
        <template v-slot:activator="{on}">
          <div v-on="on">
            {{ category.short }}
          </div>
        </template>
        <span class="caption">{{ category.long }}</span>
      </v-tooltip>

      <div v-else
           :key="category.short"
           class="single-versicherungsumfang">
        {{ category.short }}
      </div>

    </template>
  </div>
</template>

<script>

const CATEGORY_NAMES = {
  P: 'Privat',
  B: 'Beruf',
  V: 'Verkehr',
  W: 'Wohnen',
  M: 'Mietrechtsschutz vor Gericht',
  I: 'Immobilie',
  F: 'Firma/Gewerbe',
  'Schnell & Sicher': 'Schnell & Sicher',
  'KOMPEX-o.Immo.': 'KOMPEX-o.Immo.',
  'AGROMEX': 'AGROMEX'
};

export default {
  name: 'Versicherungsumfang',
  props: {
    categories: {
      type: String,
      required: true
    }
  },
  computed: {
    categoriesInfo() {
      let splittedCategories = this.categories.split(/\s+/);
      if(this.categories == 'Schnell & Sicher'){
        splittedCategories = [].concat('Schnell & Sicher');
      }
      else if(this.categories[0] == 'Schnell & Sicher' 
              || this.categories[0] == 'KOMPEX-o.Immo.'
              || this.categories[0] == 'AGROMEX' ){
        splittedCategories = this.categories;
      }
      return splittedCategories.map(category => ({ short: category, long: CATEGORY_NAMES[category] }));
    }
  }
};
</script>

<style>
.versicherungsumfang {
  display: flex;
  flex-direction: row;
}

.versicherungsumfang .single-versicherungsumfang:not(:last-child) {
  margin-right: 4px;
}

.single-versicherungsumfang.tooltip {
  position: unset;
}

</style>
